<template>
  <div class="description-wrapper">
    <header class="info-header">
      <h5 class="text-gray display-inline-block info-block-label text-uppercase">{{ $t('CALENDAR_ACTIVITY.activityHeader.description.title')}}</h5>
      <div class="btns-wrapper fa-pull-right">
        <!-- <button class="btn btn-black-bkg btn-no-border edit-btn" v-if="!editDescFormOpened" @click="editDescFormOpened = !editDescFormOpened">
          <img src="@/assets/images/icons/edit-icon.png" alt="edit-icon">
        </button> -->
        <button class="btn btn-black-bkg btn-no-border confirm-btn" v-if="editDescFormOpened" @click="saveDescription">
          <img src="@/assets/images/icons/confirm-icon.png" alt="confirm-icon">
        </button>
        <!-- <button class="btn btn-black-bkg btn-no-border" v-if="editDescFormOpened" @click="cancelEdittingDescription">
          <img src="@/assets/images/icons/remove-icon.png" alt="confirm-icon">
        </button> -->
      </div>
    </header>
    <div class="description-content">
      <!-- <span class="activity-description" v-if="!editDescFormOpened">
        {{description || '/'}}
      </span> -->
      <div class="form-group desc-form-group">
        <textarea :placeholder="$t('CALENDAR_ACTIVITY.activityHeader.description.placeholder')" @focus="editDescFormOpened = true" class="desc-textarea form-control form-control-default" v-model="descriptionModel" name="description" id="activityDescriptionTextArea" data-gramm_editor= false ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { TOASTER_ERROR } from '@/common/events.types'
import { FocusField } from '@/directives/FocusFieldDirective'

export default {
  name: 'CalendarActivityDescription',
  props: [
    'description',
    'activityId',
    'updateActivityDescription'
  ],
  data () {
    return {
      editDescFormOpened: false,
      descriptionModel: this.description
    }
  },
  methods: {
    filterDescriptionString () {
      return this.descriptionModel
        .replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
    },

    saveDescription () {
      const editedDesc = this.filterDescriptionString()

      if(editedDesc !== null && editedDesc.length > 500) {
        this.$eventHub.$emit(TOASTER_ERROR, {
          message: this.$t('CALENDAR_ACTIVITY.toastMessages.noMoreThan500')
        });
      } else {
        this.updateActivityDescription({
          activityId: this.activityId,
          description: editedDesc
        })
        .then(() => {
          this.editDescFormOpened = false
        })
        .catch(err => {
          this.$eventHub.$emit(TOASTER_ERROR, {
            message: this.$t('TOAST_MESSAGES.errorTryAgain')
          });
        })
      }
    },
    cancelEdittingDescription () {
      this.editDescFormOpened = false

      this.descriptionModel = this.description
    }
  },
  directives: {
    FocusField
  }
}
</script>

<style lang="scss" scoped>
  .info-block-label {
    font-size: 14px;
  }

  .info-header {
    max-width: 450px;
    .btn {
      padding: 0 4px;
    }
  }  

  .confirm-btn {
    background-color: #4B4B4F;
  }

  .form-group textarea {
    font-size: 14px;
    height: 150px;
    border-radius: 0;
    border: 1px solid #636363;
    max-width: 450px;
    background-color: #242424;

    &:focus {
      background-color: $shark-gray-4;
    }
  }

  .desc-form-group {
    height: 50px;
  }

  .description-content {
    height: 150px;
  }

  .desc-textarea {
    height: auto;
    white-space: unset;
  }

  .activity-description {
    font-size: 14px;
  }
</style>
